import { render } from "./tableFilter.vue?vue&type=template&id=dffcba84&scoped=true"
import script from "./tableFilter.vue?vue&type=script&lang=js"
export * from "./tableFilter.vue?vue&type=script&lang=js"

import "./tableFilter.vue?vue&type=style&index=0&id=dffcba84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dffcba84"]])

export default __exports__